<script>
import API from "@/api/outers/IBGE";
import errorMixin from "@/mixins/errorMixin";

export default {
  mixins: [errorMixin],

  props: {
    state: [Object, Number],
    value: {
      type: [Object, Number],
      default: 0
    },
    error: Boolean
  },

  data() {
    return {
      city: 0,
      cities: [],
      loading: false
    };
  },

  computed: {
    errorText() {
      return this.error ? "O campo Cidade é obrigatório!" : "";
    }
  },

  methods: {
    async getCities() {
      try {
        if (!this.state) return;

        this.loading = true;
        this.cities = await API.getCities(this.state.id);
        this.loading = false;
      } catch (e) {
        this.$emit("error");
      }
    }
  },

  watch: {
    state() {
      this.getCities();
    },
    async city(id) {
      if (!this.cities.length) await this.getCities();
      let city = this.cities.find(el => el.id == id);
      this.$emit("input", city);
    }
  },

  async mounted() {
    await this.getCities();
    if (this.value) this.city = this.value.id;
  }
};
</script>

<template>
    <base-select
      :error="errorText"
      v-model="city"
      label="Cidade"
      :disabled="!state"
      :loading="loading"
    >
      <option value="0" disabled selected></option>
      <option v-for="(city, index) in cities" :key="index" :value="city.id">{{city.nome}}</option>
    </base-select>
</template>



// WEBPACK FOOTER //
// src/components/_Shared/IBGE/Cities.vue